import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import { Avatar, Box, Card, Skeleton, Typography } from '@mui/material';
import dinero from 'dinero.js';
import React from 'react';

interface SubscriberCounterProps {
    count: number;
    label?: string;
    color?: string;
    iconColor?: string;
    isCurrency?: boolean;
    isLoading?: boolean;
}

const SubscriberCounter: React.FC<SubscriberCounterProps> = ({
    count,
    label = 'Total Subscribers',
    color = '#b5651d', // Default to the brown/orange color from the image
    iconColor = 'rgba(255, 255, 255, 0.7)', // More visible icon color with contrast
    isCurrency = false,
    isLoading = false,
}) => {
    // Function to format currency using dinero.js
    const formatCurrency = (amount: number) => {
        // Convert amount to cents for dinero.js (which works with integer values)
        const amountInCents = Math.round(amount * 100);
        const money = dinero({ amount: amountInCents, currency: 'USD' });

        // Format with dinero.js
        return money.toFormat();
    };

    // Format the number based on type
    const formattedCount = isCurrency ? formatCurrency(count) : new Intl.NumberFormat().format(count);

    return (
        <Card
            sx={{
                bgcolor: color,
                color: 'white',
                p: 3,
                display: 'flex',
                alignItems: 'center',
                borderRadius: 1,
                boxShadow: 2,
            }}
        >
            <Avatar
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.2)',
                    color: iconColor,
                    mr: 3,
                    width: 56,
                    height: 56,
                }}
            >
                {isCurrency ? <AttachMoneyIcon fontSize="large" /> : <PeopleIcon fontSize="large" />}
            </Avatar>

            <Box>
                <Typography variant="h5" component="div" fontWeight="bold">
                    {isLoading && <Skeleton variant="text" width={100} sx={{ fontSize: '1rem', ml: 1 }} />}
                    {!isLoading && formattedCount}
                </Typography>

                <Typography
                    variant="subtitle1"
                    sx={{
                        opacity: 0.9,
                        mt: 0.5,
                    }}
                >
                    {label}
                </Typography>
            </Box>
        </Card>
    );
};

export default SubscriberCounter;
